import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AccommodationType } from '../accommodation-type';
import { BoardType } from '../board-type';
import { BookingPost } from '../booking-post';
import { Country } from '../country';
import { Gender } from '../gender';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { LanguageCourse } from '../language-course';
import { RoomType } from '../room-type';
import { SalesAgent } from '../sales-agent';
import { School } from '../school';
import { SimpleBookingItem } from '../simple-booking-item';
import { StudentPost } from '../student-post';
import { TargetLanguageLevel } from '../target-language-level';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-create-single-booking',
  templateUrl: './create-single-booking.component.html',
  styleUrls: ['./create-single-booking.component.css']
})
export class CreateSingleBookingComponent implements OnInit {

  bookingForm: FormGroup;
  countries: Country[] = [];
  schools: School[] = [];
  accommodationTypes: AccommodationType[] = [];
  roomTypes: RoomType[] = [];
  boardTypes: BoardType[] = [];
  salesAgents: SalesAgent[] = [];
  languageLevels: TargetLanguageLevel[] = [];
  bookingYearRange = (moment().year() - 2) + ":" + (moment().year() + 5);
  birthYearRange = (moment().year() - 80) + ":" + (moment().year());
  languages: Language[] = [];
  bookings: SimpleBookingItem[] = [];
  genders: Gender[] = [];
  languageCourses: LanguageCourse[] = [];
  formInvalid = false;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private router: Router
  ) {
    this.bookingForm = builder.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      destination: [null, Validators.required],
      school: [null, Validators.required],
      studentFirstName: [null, Validators.required],
      studentLastName: [null, Validators.required],
      accommodationType: [null, Validators.required],
      roomType: [null, Validators.required],
      boardType: [null, Validators.required],
      targetLanguageLevel: [null, Validators.required],
      studentLanguage: [null, Validators.required],
      studentGender: null,
      studentAllergies: null,
      studentBirthDate: null,
      salesAgent: [null, Validators.required],
      languageCourse: [null, Validators.required]
    });
   }

  ngOnInit(): void {
    this.httpService.getAllCountries().subscribe(res => {
      this.countries = res;
    });
    this.httpService.getAccommodationTypes().subscribe(res => {
      this.accommodationTypes = res;
    });
    this.httpService.getRoomTypes().subscribe(res => {
      this.roomTypes = res;
    });
    this.httpService.getBoardTypes().subscribe(res => {
      this.boardTypes = res;
    });
    this.httpService.getTargetLanguageLevels().subscribe(res => {
      this.languageLevels = res;
    });
    this.httpService.getSalesAgents().subscribe(res => {
      this.salesAgents = res;
    });
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
      this.bookingForm.get("studentLanguage")!.setValue(this.languages[0]);
    });
    this.httpService.getRecentSimpleBookingItems().subscribe(res => {
      this.bookings = res;
    });
    this.httpService.getGenders().subscribe(res => {
      this.genders = res;
    });

  }

  updateSchoolList(countryId: number){
    this.httpService.getSchoolsByDestination(countryId).subscribe(res => {
      this.schools = res;
    });
  }

  submitBooking(){
    if(this.bookingForm.valid){
      this.formInvalid = false;
      let newPostBooking = new BookingPost(
        moment(this.bookingForm.value.startDate).utc(true),
        moment(this.bookingForm.value.endDate).utc(true),
        this.bookingForm.value.school.id,
        this.bookingForm.value.destination.id,
        new StudentPost(
          this.bookingForm.value.studentFirstName,
          this.bookingForm.value.studentLastName,
          this.bookingForm.value.studentLanguage.id,
          this.bookingForm.value.studentGender?.id,
          null,
          this.bookingForm.value.studentAllergies,
          this.bookingForm.value.studentBirthDate
        ),
        this.bookingForm.value.salesAgent.id,
        this.bookingForm.value.accommodationType.id,
        this.bookingForm.value.roomType.id,
        this.bookingForm.value.boardType.id, 
        null,
        null,
        null,
        null,
        this.bookingForm.value.targetLanguageLevel.id,
        this.bookingForm.value.languageCourse.id
      );
      this.httpService.postSingleBooking(newPostBooking).subscribe(res => {
        this.router.navigateByUrl("/management/edit-booking/" + res);
      });
    } else {
      this.formInvalid = true;
      this.toastService.addError("Error", "Please complete the form");
    }
  }

  onSchoolChange(){
    if(this.bookingForm.value && this.bookingForm.value.school){
      this.loadLanguageCourses(this.bookingForm.value.school);
    }
  }

  loadLanguageCourses(school: School){
    this.httpService.getLanguageCoursesBySchoolId(school.id!).subscribe(res => {
      this.bookingForm.get("languageCourse")!.setValue(null);
      this.languageCourses = res;
    });
  }

  onDestinationChange(selectedCountry: Country){
    this.updateSchoolList(selectedCountry.id);
  }

  importBooking(simpleBooking: SimpleBookingItem){
    this.httpService.getBookingById(simpleBooking.id).subscribe(booking => {
      this.bookingForm.get("studentFirstName")!.setValue(booking.student.firstName);
      this.bookingForm.get("studentLastName")!.setValue(booking.student.lastName);
      this.bookingForm.get("targetLanguageLevel")!.setValue(booking.targetLanguageLevel);
      if(booking.student.birthDay){
        this.bookingForm.get("studentBirthDate")!.setValue(moment(booking.student.birthDay).toDate());
      }
      this.bookingForm.get("studentAllergies")!.setValue(booking.student.allergies);
      this.bookingForm.get("studentGender")!.setValue(booking.student.gender);
      this.bookingForm.get("studentLanguage")!.setValue(booking.student.language);
    });
  }

}
